import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import { SmartCropS7Enhancer } from './SmartCropS7Enhancer.mjs';

const Image = polymorphicFactory(
  (props, ref) => {
    const {
      component = "img",
      src,
      srcSet,
      alt,
      className,
      width = "100%",
      height = "100%",
      objectFit = "cover",
      position = "relative",
      objectPosition = "center",
      ...rest
    } = props;
    const classNames = clsx("kohler-image-root", className);
    const isSmartCrop = rest["data-mode"] === "smartcrop";
    const imageElement = /* @__PURE__ */ React.createElement(
      Box,
      {
        className: classNames,
        component,
        ref,
        src,
        srcSet,
        alt,
        position,
        width,
        height,
        objectFit,
        objectPosition,
        ...rest
      }
    );
    return isSmartCrop ? /* @__PURE__ */ React.createElement(SmartCropS7Enhancer, null, imageElement) : imageElement;
  }
);

export { Image };
